import { cx } from '@linaria/core';
import { aspectRatio, appletContainer } from './_content.style.js';
import { jsx } from 'react/jsx-runtime';

function GeogebraContent(props) {
  return /*#__PURE__*/jsx("div", {
    className: aspectRatio,
    style: {
      paddingBottom: `${props.aspectRatio * 100}%`
    },
    children: /*#__PURE__*/jsx("div", {
      className: cx(appletContainer, props.appletClassName),
      children: /*#__PURE__*/jsx("div", {
        ref: props.ref
      })
    })
  });
}

export { GeogebraContent };
//# sourceMappingURL=_content.js.map
